import type { CSSProperties } from 'react';

/**
 * Warm brown "surface-2" sub-card look from the mockup, built from CO tokens so
 * it stays theme-aware (a faint burgundy tint over the card colour).
 */
export const SUB_CARD_STYLE: CSSProperties = {
  backgroundColor: 'color-mix(in srgb, var(--burgundy-core) 4%, var(--card))',
  borderColor: 'var(--border)',
  boxShadow: 'var(--shadow-warm-sm)',
};

export const SUB_CARD_CLASS = 'rounded-lg border p-4';

/** Milestone bands the score climbs through. */
export const MILESTONES = ['DORMANT', 'WARMING', 'ACTIVE', 'ON FIRE'] as const;

/** Adherence → green/amber/red, matching the calendar + rows colour coding. */
export function adherenceColor(adherence: number): string {
  if (adherence >= 0.7) return 'var(--success-green)';
  if (adherence >= 0.4) return 'var(--status-warning)';
  return 'var(--alert-red)';
}

/**
 * Continuous amber→green "quality" gradient — the SAME warm→good ramp used by the
 * week planned bars and the milestone track, for consistency. Revealed left→right
 * to a day's adherence: where the gradient stops encodes how good the day was
 * (empty = no activity).
 */
export const DAY_QUALITY_GRADIENT =
  'linear-gradient(90deg, var(--status-warning) 0%, var(--success-green) 100%)';

export const WEEKDAY_LABELS = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
